import DateFormatter from './DateFormatter'
import TimeFormatter from './TimeFormatter'

export default function format(text: any) {
  const textFormatters = [
    new DateFormatter(
      /{{2}date\((\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{0,6})?(?:z|Z|-\d{1,2}))(?:,\s*)([^)]*)\)}{2}/gi
    ),
    new TimeFormatter(/{{2}time\((\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{0,6})?(?:z|Z|-\d{1,2}))\)}{2}/gi)
  ]

  let formattedText = text

  textFormatters.forEach(formatter => {
    formattedText = formatter.format(formattedText)
  })

  return formattedText
}
